import { useState, useEffect } from 'react';

export default function useWpPage(slug) {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${window.wpData.restUrl}react-pages/v1/page?slug=${slug}`, {
      headers: { 'X-WP-Nonce': window.wpData.nonce },
      credentials: 'same-origin'
    })
    .then(res => res.json())
    .then(setData)
    .catch(() => setData(null));
  }, [slug]);
  return data;
}
